<div class="modal fade" id="magicInsightsGenerationModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="magicInsightsGenerationModalLabel"><i class="far fa-sparkle"></i> Generate Magic
          Insights</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
              <p>Magic Insights will be generated for @if(numberOfCompaniesMatchingSearchParams){ {{numberOfCompaniesMatchingSearchParams}} {{numberOfCompaniesMatchingSearchParams | i18nPlural:pluralMappings.company}} } @else {<zint-loader size="xSmall" [isInline]="true"></zint-loader>} matching your search criteria.</p>

              @if (showSelectionWarning) {
                <p class="status-badge-base status-badge-orange">Please select a maximum of {{ maximumCompaniesToGenerateViaQuery }} companies to generate insights for.</p>
              }

              <label>Maximum number of companies to generate insights for (optional):</label>
              <input type="number" min="1" max="50000" class="form-control mb-4" placeholder="optional" [(ngModel)]="selectedMagicInsightsGenerateCount">

              <span>Select Magic Insights Module:</span>
              <div class="bg-light mb-2 pt-2 pl-2 max-height-20vh">
                @for (module of modulesInfo; track $index) {
                  <label class="full-width">
                    <input type="radio" [value]="module.id" [(ngModel)]="selectedModuleId" name="selectedModules" (ngModelChange)="handleSelectedModuleIdsChange()"/>
                    {{ module.name }}
                  </label>
                }
              </div>

              @if (canConfirmGeneration) {
                <button class="d-block mx-auto my-3 rounded-btn-base rounded-btn-vivid-outline btn-p-lg"
                        [disabled]="!selectedMagicModuleIds?.length || loadingState.loadingGenerateMagicInsights"
                        (click)="confirmGenerateMIForSelectedCompanies()">
                  <i class="fal fa-check mr-1"></i>Generate
                </button>
              }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
